export const dateFromTimestamp = (timestamp: Date) => {
  const date = new Date(timestamp)
  // should return date in format like "July 10, 12:15"
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  })
    .format(date)
    .replace(' at', ', ')
}
